import axios from 'axios';
import { uniq } from 'lodash';

import { TransferPool, TransferPoolCustomer, TransferPoolPallet } from './types';

export const fetchTransferPool = (id: string) =>
  axios.get<TransferPool>(`/transferpools/${encodeURIComponent(id)}.json`).then(({ data }) => data);

export const fetchTransferPoolPallets = (id: string) =>
  axios.get<TransferPoolPallet[]>(`/transferpools/${encodeURIComponent(id)}/pallets.json`).then(({ data }) => data);

const accountIdsFromPallets = (pallets: TransferPoolPallet[]) =>
  uniq(pallets.flatMap((pallet) => pallet.items.map((item) => item.account_id)));

export const fetchPrimaryCustomersForPallets = (pallets: TransferPoolPallet[]) => {
  const accountIds = accountIdsFromPallets(pallets);
  if (!accountIds.length) {
    return Promise.resolve([] as TransferPoolCustomer[]);
  }

  return axios
    .get<TransferPoolCustomer[]>('/customers.json', {
      params: { account_ids: accountIds },
    })
    .then(({ data }) => data.filter((customer) => customer.primary));
};

export const attachPrimaryCustomers = (
  pallets: TransferPoolPallet[],
  customers: TransferPoolCustomer[],
): TransferPoolPallet[] =>
  pallets.map((pallet) => ({
    ...pallet,
    primaryCustomers: customers.filter((customer) =>
      pallet.items.some((item) => item.account_id === customer.account_id),
    ),
  }));
